<template functional>
  <div
    :class="[
      'search-bar',
      {
        'opacity-bg': props.onTop
      }
    ]"
    @click="listeners['go-search']"
  >
    <div class="input">
      <IconFont name="sousuokuang" />
      <span class="hot-words">搜索冻品</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onTop: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  box-sizing: border-box;

  width: 100%;
  height: 100%;

  padding: 0 11px;

  background-color: $c-background-grey-6;
  border-radius: 30px;

  font-size: 13px;

  line-height: 30px;

  transition: background-color ease-in-out 0.4s;

  ::v-deep i {
    font-size: 13px;
    color: $c-text-lighter;
  }

  .hot-words {
    margin-left: 7px;

    color: $c-text-lighter;
  }
}

.search-bar {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;

  z-index: $z-navigation-bar;

  width: 100%;
  height: 44px;
  padding: 7px 15px;

  background-color: white;

  transition: background-color ease-in-out 0.4s;

  &.opacity-bg {
    background-color: rgba(255, 255, 255, 0);

    .input {
      background-color: white;
    }
  }
}
</style>
